import Button from '@allesauto/core/button';
import CircularLoader, {
  CircularLoaderType,
} from '@allesauto/core/circularLoader';
import TextLink from '@allesauto/core/textLink';
import translate from '@allesauto/i18n';
import { Close16 } from '@carbon/icons-react';
import clsx from 'clsx';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

interface ActionFooterBarProps {
  buttonText: string;
  onButtonClick: () => void;
  onTextLinkClick?: () => void;
  isDisabled?: boolean;
  customClass?: string;
  isLoading?: boolean;
}

const ActionFooterBar: FC<React.PropsWithChildren<ActionFooterBarProps>> = ({
  buttonText,
  onButtonClick,
  onTextLinkClick,
  isDisabled = false,
  isLoading = false,
  customClass,
}) => {
  const intl = useIntl();
  const text = translate(intl, buttonText);

  const className = {
    containerClass: clsx(
      'bg-white flex justify-center sm:flex-col-reverse sm:pb-20px sm:pt-0 sm:px-15px lg:flex-row lg:justify-between lg:p-40px',
      customClass
    ),
    textLinkCustomClass: 'self-center mt-20px lg:self-auto lg:mt-0',
  };

  return (
    <div className={className.containerClass}>
      <TextLink
        text={translate(intl, 'ui.SERVICE_BOOKING.CANCEL_TEXT')}
        icon={<Close16 />}
        onClick={onTextLinkClick}
        customClassName={className.textLinkCustomClass}
      />
      <Button
        type="button"
        onClick={onButtonClick}
        disabled={isDisabled}
        isLoading={isLoading}
      >
        {isLoading ? (
          <CircularLoader type={CircularLoaderType.primary} />
        ) : (
          text
        )}
      </Button>
    </div>
  );
};

export default ActionFooterBar;
